import React, { Component } from 'react'
import Immutable from 'immutable';
import NotFoundData from '../modules/not-found-data';
import IsFetching from '../modules/is-fetching';
import InnerHeader from '../modules/inner-header';
import FormValidizr from '../form-validizr/form-validizr';
import Tooltip from '../modules/tooltip';
import { getIndex, getIdEnterprise } from '../../utilities/utilities';
import Disclaimer from '../modules/disclaimer';

export default class NewEnterprise extends Component {
    constructor(props) {
        super(props)
        this.handleNewEnterpriseButton = this.handleNewEnterpriseButton.bind(this);
        this.checkboxHandler = this.checkboxHandler.bind(this);
        this.inputHandler = this.inputHandler.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentWillMount = () => {
        this.props.resetFormModalEnterprise();
    }
    handleNewEnterpriseButton = () => {
        this.props.setModal("enterpriseFormModal");
    }
    checkboxHandler(target, event) {
        const { adminEnterprisesStates } = this.props,
            features = adminEnterprisesStates.getIn(['enterpriseFormModal', 'features']),
            value = event.target.value;

        if (features.includes(value)) {
            const index = getIndex(value, features);
            this.props.removeEnterpriseModalFeature(index);
        } else {
            this.props.addEnterpriseModalFeature(value);
        }
    }
    handleSubmit() {
        const { adminEnterprisesStates } = this.props,
            data = adminEnterprisesStates.get('enterpriseFormModal').toJS(),
            featuresEnterprise = adminEnterprisesStates.getIn(['enterpriseFormModal', 'features']),
            allFeatures = adminEnterprisesStates.get('allFeatures');
        allFeatures.forEach(feat => {
            data[feat] = featuresEnterprise.includes(feat) ? 1 : 0;
        });
        data.activada = data.activada ? 1 : 0;
        delete data.features;
        delete data.id;
        this.props.createEnterprise(data, "create");
    }
    inputHandler(target, event) {
        const { adminEnterprisesStates } = this.props,
            enterpriseForm = adminEnterprisesStates.get('enterpriseFormModal');
        let value = event.target.value;

        if (event.target.type == 'checkbox')
            value = !enterpriseForm.get(target);

        this.props.changeFormModalFieldsEnterprise(target, value)
    }
    getFormFieldsets() {
        const { adminEnterprisesStates } = this.props,
            enterpriseForm = adminEnterprisesStates.get('enterpriseFormModal');

        let formFields = [
            {
                title: 'Datos empresa',
                fieldsetClass: 'grid-6',
                data: [
                    {
                        tag: 'input',
                        type: 'text',
                        name: 'enterprise-nombre',
                        labelClass: 'grid-10',
                        invalidSetup: {
                            icons: {
                                valid: 'icon-element check field-icon',
                                invalid: 'icon-element rounded info red field-icon',
                            },
                            tooltip: <Tooltip type="red" additionalClass="error in-field" content="Debes ingresar un nombre para la empresa" />
                        },
                        placeholder: 'Ingrese el nombre de la empresa',
                        value: enterpriseForm.get('nombre'),
                        label: 'Nombre:',
                        onChangeFunc: this.inputHandler.bind(null, 'nombre'),
                        validators: ['required']
                    },
                    {
                        tag: 'input',
                        type: 'checkbox',
                        name: 'activada',
                        labelClass: 'grid-10',
                        checked: enterpriseForm.get('activada'),
                        value: enterpriseForm.get('activada'),
                        label: 'Activar',
                        positionLabel: 'top',
                        onChangeFunc: this.inputHandler.bind(null, 'activada')
                    },
                    {
                        tag: 'input',
                        type: 'text',
                        name: 'enterprise-workspace-id',
                        labelClass: 'grid-10',
                        invalidSetup: {
                            icons: {
                                valid: 'icon-element check field-icon',
                                invalid: 'icon-element rounded info red field-icon',
                            },
                            tooltip: <Tooltip type="red" additionalClass="error in-field" content="Debes ingresar un workspace id para la empresa" />
                        },
                        placeholder: 'Ingrese el workspace id de la empresa',
                        value: enterpriseForm.get('workspace_id'),
                        label: 'Workspace ID:',
                        onChangeFunc: this.inputHandler.bind(null, 'workspace_id'),
                        validators: ['required']
                    },
                    {
                        tag: 'input',
                        type: 'text',
                        name: 'enterprise-workspace-user',
                        labelClass: 'grid-10',
                        invalidSetup: {
                            icons: {
                                valid: 'icon-element check field-icon',
                                invalid: 'icon-element rounded info red field-icon',
                            },
                            tooltip: <Tooltip type="red" additionalClass="error in-field" content="Debes ingresar un workspace user para la empresa" />
                        },
                        placeholder: 'Ingrese el workspace user de la empresa',
                        value: enterpriseForm.get('workspace_user'),
                        label: 'Workspace user:',
                        onChangeFunc: this.inputHandler.bind(null, 'workspace_user'),
                        validators: ['required']
                    },
                    {
                        tag: 'input',
                        type: 'text',
                        name: 'enterprise-workspace-password',
                        labelClass: 'grid-10',
                        invalidSetup: {
                            icons: {
                                valid: 'icon-element check field-icon',
                                invalid: 'icon-element rounded info red field-icon',
                            },
                            tooltip: <Tooltip type="red" additionalClass="error in-field" content="Debes ingresar un workspace password para la empresa" />
                        },
                        placeholder: 'Ingrese el workspace password de la empresa',
                        value: enterpriseForm.get('workspace_password'),
                        label: 'Workspace password:',
                        onChangeFunc: this.inputHandler.bind(null, 'workspace_password'),
                        validators: ['required']
                    },
                    {
                        tag: 'input',
                        type: 'text',
                        name: 'enterprise-database-name',
                        labelClass: 'grid-10',
                        invalidSetup: {
                            icons: {
                                valid: 'icon-element check field-icon',
                                invalid: 'icon-element rounded info red field-icon',
                            },
                            tooltip: <Tooltip type="red" additionalClass="error in-field" content="Debes ingresar un database name para la empresa" />
                        },
                        placeholder: 'Ingrese el database name de la empresa',
                        value: enterpriseForm.get('database_name'),
                        label: 'Database name:',
                        onChangeFunc: this.inputHandler.bind(null, 'database_name'),
                        validators: ['required']
                    },
                ]
            },

        ];

        formFields.push({
            title: 'Features de empresa',
            fieldsetClass: 'grid-6',
            data: this.fillFeatures()
        })
        return formFields;
    }
    getLabelFeature = (feature) => {
        switch (feature) {
            case 'enable_dashboard':
                return 'Dashboard'
            case 'enable_templates':
                return 'Plantillas'
            case 'enable_campaigns':
                return 'Campañas'
            case 'enable_users':
                return 'Usuarios'
            case 'enable_assistant':
                return 'Asistente'
            case 'enable_concurrency_setup':
                return 'Concurrency setup'
            case 'enable_payment_method':
                return 'Método de pago'
            case 'enable_whatsapp':
                return 'Whatsapp'
            case 'enable_edit_button':
                return 'Editar botón correo'
            case 'enable_customers_assigned':
                return 'Clientes asignados'
            case 'enable_channel_voice':
                return 'Voz'
            default:
                break;
        }
    }
    fillFeatures = () => {
        const { adminEnterprisesStates, } = this.props,
            features_form = adminEnterprisesStates.getIn(['enterpriseFormModal', 'features']),
            allFeatures = adminEnterprisesStates.get('allFeatures');
        return allFeatures.map(feat => {
            return (
                {
                    tag: 'input',
                    type: 'checkbox',
                    name: feat,
                    checked: features_form.includes(feat),
                    value: feat,
                    label: this.getLabelFeature(feat),
                    onChangeFunc: this.checkboxHandler.bind(null, feat)
                }
            )
        });
    }
    //Debe crear empresas y sus features
    getContent = () => {
        const { adminEnterprisesStates } = this.props,
            error = adminEnterprisesStates.get('error'),
            formFieldsets = this.getFormFieldsets();
        let content = null;

        if (error) {
            content = (
                <NotFoundData
                    text={error}
                    buttonText="Intentar nuevamente"
                    buttonFunc={this.fetchData}
                />
            );
        } else {
            content = (
                <FormValidizr
                    formSubmitHandler={this.handleSubmit}
                    formButton={{
                        buttonClass: 'btn',
                        text: 'Crear empresa',
                        holder: 'align-center'
                    }}
                    formFields={formFieldsets}
                />
            )
        }
        return content;
    }
    getSuccessMessage() {
        const { adminEnterprisesStates } = this.props,
            message = adminEnterprisesStates.get('messageForm');
        if (message.length > 0)
            return <Disclaimer type={'success'} content={message} />
    }
    getWarningMessage() {
        const { adminEnterprisesStates } = this.props,
            message = adminEnterprisesStates.get('error');
        if (message.length > 0)
            return <Disclaimer type={'warning'} content={message} />
    }
    render() {
        const content = this.getContent(),
            { adminEnterprisesStates } = this.props,
            successMessage = this.getSuccessMessage(),
            warningMessage = this.getWarningMessage();
        return (
            <IsFetching isFetching={adminEnterprisesStates.get('isFetching')} showChildren={true}>
                <header className="modal-header">
                    <h3 className="modal-title">{"Nueva empresa"}</h3>
                </header>
                <div className="inner-content">
                    {successMessage}
                    {warningMessage}
                </div>
                {content}
            </IsFetching>

        )
    }
}
